<div class="container">
  <div class="page-container">
    <div class="header-content">
      <h2>Edit {{ pageName }}</h2>
      <button (click)="savePage()" color="primary" mat-flat-button>Save Page</button>
    </div>
    <div class="content">
      <div class="w-100-1">
        <form [formGroup]="legalForm" class="legal-page-form">
          <mat-form-field class="w-25-4">
            <mat-label>Name</mat-label>
            <input formControlName="name" readonly matInput />
          </mat-form-field>
          <ckeditor [editor]="editor" class="w-100-1 editor" formControlName="pageHtml"></ckeditor>
        </form>
      </div>
    </div>
  </div>
</div>
